module.exports = __webpack_public_path__ + "img/FeatureStarSelected.f8793238.svg";